import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { onboardingQueryKeyFactory } from "../queryKeyFactory";

export function useOnboardingInitQuery() {
    return useQuery<OnboardingInitData>({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: onboardingQueryKeyFactory.onboardingInitData(),
        throwOnError: true,
        queryFn: async (): Promise<OnboardingInitData> => {
            return await salesApiService.onboarding.fetchOnboardingInitData();
        },
    });
}
